import { Location } from './location';
import { Trainer } from './trainer';

export class CourseDay {
  Date: Date;
  TimeFrom: string;
  TimeTill: string;
  Description: string;
  Trainers: Trainer[];
  Locations: Location[];
}
